const {
    ROOT_BASKET_TYPES: { PRE_BASKET, MAIN_BASKET },
    MAIN_BASKET_TYPES: { DC_BASKET, BOPIS_BASKET },
    DC_BASKET_TYPES: { SAMEDAY_BASKET, AUTOREPLENISH_BASKET, STANDARD_BASKET },
    SAMEDAY_TYPES,
    CART_SECTION_BANNERS: { SDD_ROUGE_INSENTIVE_BANNER }
} = require('constants/RwdBasket');

function calculateCartQuantity(items) {
    return items.reduce((acc, item) => acc + item.qty, 0);
}

function getPickupFromStoreInfo({ pickupBasket }) {
    const { isROPISEnabled, isBOPISEnabled } = Sephora.configurationSettings;
    const bopisIsEnabled = isROPISEnabled || isBOPISEnabled;

    if (pickupBasket == null) {
        return {
            isAvailable: false,
            totalQuantity: 0
        };
    }

    const { items, pickupMessage, storeDetails, pickupOrderNotificationMsg } = pickupBasket;

    return {
        isAvailable: bopisIsEnabled && items.length > 0,
        items,
        totalQuantity: calculateCartQuantity(items),
        pickupMessage,
        pickupOrderNotificationMsg,
        storeDetails
    };
}

function getSameDayDeliveryInfo({ itemsByBasket, SDDRougeTestThreshold, SDDRougeTestRemainToFreeShipping }) {
    const { isSameDayShippingEnabled } = Sephora.configurationSettings;
    const sdd = itemsByBasket?.find(e => e.basketType === SAMEDAY_BASKET);

    if (sdd == null) {
        return {
            isAvailable: false,
            totalQuantity: 0
        };
    }

    const { items, sameDayDeliveryMessage, sameDayTitle } = sdd;
    const isSDDRougeTestFreeShipping = !!SDDRougeTestThreshold;

    return {
        items,
        totalQuantity: calculateCartQuantity(items),
        isAvailable: isSameDayShippingEnabled,
        sameDayDeliveryMessage,
        sameDayTitle,
        isSDDRougeTestFreeShipping,
        SDDRougeTestRemainToFreeShipping,
        isSDUOnlyInBasket: items.length === 1 && items[0].sku.type === SAMEDAY_TYPES.SDU,
        SDDRougeTestThreshold
    };
}

function getStandardShippingInfo({ itemsByBasket, remainToFreeShipping }) {
    const standard = itemsByBasket?.find(e => e.basketType === STANDARD_BASKET);
    const standardFiltered = standard?.items.filter(item => !item.isReplenishment);

    if (standard == null || standardFiltered.length === 0) {
        return { isAvailable: false, totalQuantity: 0 };
    }

    return { items: standardFiltered, totalQuantity: calculateCartQuantity(standardFiltered), isAvailable: true, remainToFreeShipping };
}

function getAutoreplenishInfo({ itemsByBasket, totalAnnualReplenishmentDiscount }) {
    const standard = itemsByBasket?.find(e => e.basketType === STANDARD_BASKET);
    const autoreplenish = standard?.items.filter(item => item.isReplenishment);

    if (standard == null || autoreplenish.length === 0) {
        return { isAvailable: false, totalQuantity: 0 };
    }

    return {
        isAvailable: true,
        items: autoreplenish,
        totalQuantity: calculateCartQuantity(autoreplenish),
        totalAnnualSavings: totalAnnualReplenishmentDiscount
    };
}

function getSddRougeInsentiveBannerInfo(basket, sddTotalQuantity) {
    return {
        isAvailable: !sddTotalQuantity > 0 && !!basket?.SDDRougeTestThreshold,
        SDDRougeTestThreshold: basket?.SDDRougeTestThreshold
    };
}

function isPreBasketAvailable(basket) {
    // As of now, the only condition for showing PreBasket is that there is a Pickup/Bopis cart
    return getPickupFromStoreInfo(basket).isAvailable;
}

function calculateRootBasketType(basket) {
    // current rule is to render PreBasket if there are Bopis items
    if (isPreBasketAvailable(basket)) {
        return {
            currentRootBasketType: PRE_BASKET,
            // currentMainBasketType will be set by user action on PreBasket
            currentMainBasketType: null
        };
    }

    return {
        currentRootBasketType: MAIN_BASKET,
        // Default MAIN_BASKET_TYPE is DC because if we had BOPIS items, we would be rendering PreBasket
        currentMainBasketType: DC_BASKET
    };
}

// Output of this functions gets passed around as `cartInfo`
// We should not have any reason to re-calculate the values being returned here (unless we have perf issues in which case we can add more HOCs)
// TODO Consider using class syntax for better code organization if the function get too comples
function calculateAvailableCarts(basket) {
    const bopisInfo = getPickupFromStoreInfo(basket);
    const samedayInfo = getSameDayDeliveryInfo(basket);
    const standardInfo = getStandardShippingInfo(basket);
    const autoreplenishInfo = getAutoreplenishInfo(basket);
    const sddRougeInsentiveBannerInfo = getSddRougeInsentiveBannerInfo(basket, samedayInfo.totalQuantity);

    return {
        getTotalItemsBopisBaskets: () => bopisInfo.totalQuantity,
        getTotalItemsShippingBaskets: () => samedayInfo.totalQuantity + standardInfo.totalQuantity + autoreplenishInfo.totalQuantity,
        [BOPIS_BASKET]: bopisInfo,
        [SAMEDAY_BASKET]: samedayInfo,
        [STANDARD_BASKET]: standardInfo,
        [AUTOREPLENISH_BASKET]: autoreplenishInfo,
        [SDD_ROUGE_INSENTIVE_BANNER]: sddRougeInsentiveBannerInfo
    };
}

function getTargetUrl(item) {
    return item.sku.fullSizeSku && item.sku.fullSizeSku.targetUrl ? item.sku.fullSizeSku.targetUrl : item.sku.targetUrl;
}

module.exports = {
    calculateRootBasketType,
    calculateAvailableCarts,
    isPreBasketAvailable,
    getTargetUrl
};
